// Hooks
import useTranslate from "hooks/useTranslate";

import "./styles.sass";

type PartnersItemProps = {
  title: string;
  description: string;
  icon: JSX.Element;
};

const PartnersItem = (props: PartnersItemProps) => {
  const { title, description, icon } = props;
  const t = useTranslate();

  return (
    <div className="PartnerItem">
      <span className="PartnerItem__title">{t(title)}</span>
      <span className="PartnerItem__description">{t(description)}</span>
      <span className="PartnerItem__icon">{icon}</span>
    </div>
  );
};

export default PartnersItem;
